import { apis } from "../../index";
import { AxiosPromise, AxiosRequestConfig } from "axios";

const BASE_URL = "https://xxl6-bbr3-kxzs.m2.xano.io/api";

const post_refund = `${BASE_URL}:M4Re3bq8/refund_order`;

// post refund order

export type postRefundOrderRequestType = Partial<{
  headers: {
    Authorization: string;
  };
  order_id: string;
  customer_rate: string;
  reason: string;
  ad_ref_no: string;
  fx_amount: string;
  inr_amount: string;
  settlement_rate: string;
  my_margin: string;
  partner_margin: string;
  document: { doc_list_id: string; file: string }[];
}>;
export type postRefundOrderResponseType = Partial<{}>;
export const postRefundOrder = (
  payload: AxiosRequestConfig<postRefundOrderRequestType>,
): AxiosPromise<postRefundOrderResponseType> => {
  return apis.post(post_refund, payload);
};
